import { messages } from './messages';

export const MOBILE_CONFIGURATION_CHECKBOX_SETTINGS = [
  {
    settingKey: 'showLocationStep',
    checkboxId: 'mobile-show-location-step',
    titleMessage: messages.showLocationStep,
    descriptionMessage: messages.showLocationStepDescription,
  },
  {
    settingKey: 'requireLocationVerification',
    checkboxId: 'mobile-require-location-verification',
    titleMessage: messages.requireLocationVerification,
    descriptionMessage: messages.requireLocationVerificationDescription,
    disabledWhen: (values) => !values.showLocationStep,
  },
];

export const MOBILE_CONFIGURATION_DROPDOWN_SETTINGS = [
  {
    settingKey: 'sortItemsBy',
    titleMessage: messages.sortItemsBy,
    items: [
      { key: 'Quantity', messageKey: messages.sortByQuantity },
      { key: 'SKU', messageKey: messages.sortBySKU },
      { key: 'Name', messageKey: messages.sortByName },
      { key: 'Location', messageKey: messages.sortByLocation },
    ],
  },
];
